import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthStore } from '../../api/auth/auth.store';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard {
  readonly authStore = inject(AuthStore);
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (this.authStore.userIsLoggedInSignal()) {
      return this.router.parseUrl('/organizations');
    }
    return true;
  }
}
